
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.962 7.625c-.754.632-2.239 1.422-2.77 1.697a.895.895 0 00-.324.274c-.358.505-1.243 1.941.139 2.098a3.377 3.377 0 012.992 3.343c0 .386 6.002.386 6.002.011a3.376 3.376 0 013.993-3.32.807.807 0 00.508-.056c.189-.103.266-.234.334-.438.159-.48-.33-.708-.83-.941l-.254-.121c-.6-.3-2.25-.396-2.25 0 0 .375-1.126 1.125-2.251 1.125-.06 0-.087-.06-.111-.126l-.059-.15-.037-.096c-.318-.823-1.07-1.504-2.044-1.504h-.864c-.682 0-1.143-.678-1.142-1.36 0-.225-.03-.437-.114-.598-.176-.335-.628-.082-.918.162zm-.717 7.422a2.624 2.624 0 11-5.248 0 2.624 2.624 0 015.248 0zm12.755 0a2.624 2.624 0 11-5.249 0 2.624 2.624 0 015.249 0z","fill":"currentColor"}})])
          )
        }
      }
    